module.exports = __webpack_public_path__ + "img/23.96e03114.png";